import { apiClient } from './client.js';

export const nlSearchApi = {
  search: (query) => apiClient.post('/nl-search', { query }),
};
